import { StyleProp, ViewStyle } from 'react-native';
import StorefrontIcon from '@shared/assets/icons/v2/storefront.svg';
import { MBView } from '@shared/components/MBView';
import { Colors } from '@shared/styles';
import { API } from '@shared/types/api';
import { MBImage } from './MBImage';
import { MBBoxedIcon } from './icon';
import { Styles } from './styles';

interface MBBusinessImageProps {
  business?: API.BusinessFragment;
  style?: StyleProp<ViewStyle>;
}

const colors = Colors.v2.avatar.business;

export function MBBusinessImage({ business, style }: MBBusinessImageProps) {
  if (!business) {
    return <MBView style={[style || Styles.channelImage, { backgroundColor: Colors.v2.gray10 }]} />;
  }

  if (!!business.img) {
    return (
      <MBImage
        style={[style || (Styles.channelImage as any), { backgroundColor: 'white' }]}
        source={{ uri: business.img }}
      />
    );
  }
  return (
    <MBBoxedIcon
      style={style as any}
      source={StorefrontIcon}
      backgroundColor={colors[business.id % colors.length]}
    />
  );
}
